import i18n from 'src/i18n';
import ConfigInfo from './ConfigInfo.vue';

const configTable = () => {
  const tableColumns = [
    {
      prop: 'sigatoka_config_ages',
      label: i18n.t('sigatoka.ages_to_evaluate'),
      minWidth: 150,
      sortable: true,
      formatter: ConfigInfo,
    },
  ];

  return { tableColumns };
};
export default configTable;
